<template>
  <div
    v-if="plan.id"
  >
    <div :class="[
      'mb-3',
      {
        'align-items-center': quotaConvosDaily < 1
      }
    ]">
      <div class="h6 media-body text-center" v-html="convosQuotaStatus"></div>
      <div class="media-right mt-3">
        <a
          v-if="quotaConvosDaily < 1"
          :href="urls.businessPlan.createNextPlan(plan.user_id)"
          class="btn btn-block btn-lg btn-primary"
        >
          Build Plan
          <i class="fa fa-arrow-right ml-1"></i>
        </a>
        <power-hour
          v-if="quotaConvosDaily > 0"
          :plan="plan"
        ></power-hour>
      </div>
    </div>

    <engagement-tracker
      ref="conversations"
      variant="container"
      label="Conversations"
      help="All business-minded conversations should be counted."
      icon="fa-comments"
      class="mb-3"
      :target="quotaConvos"
      type="App\Engagements\Simple\Conversation"
      :user-id="plan.user_id"
      :period="period"
    >
      <engagement-tracker
        variant="nested"
        label="People I know"
        type="App\Engagements\Simple\Conversation"
        lead-source="General/Known"
        :user-id="plan.user_id"
        :period="period"
      ></engagement-tracker>
      <engagement-tracker
        variant="nested"
        label="People I don't know"
        type="App\Engagements\Simple\Conversation"
        lead-source="General/Unknown"
        :user-id="plan.user_id"
        :period="period"
      ></engagement-tracker>
    </engagement-tracker>

    <hr style="margin: 1rem -1.3rem !important;">

    <!--
    <engagement-tracker
      label="Appointments"
      help="All appointments set, both buyer- and listing-side, should be counted."
      variant="container"
      icon="fa-calendar"
      class="mb-3"
      type="App\Engagements\Simple\Appointment"
      :user-id="plan.user_id"
      :period="period"
    >
      <engagement-tracker
        v-for="leadSource in leadSources"
        :key="leadSource.name"
        :label="leadSourceName(leadSource)"
        variant="nested"
        type="App\Engagements\Simple\Appointment"
        :lead-source="leadSourceName(leadSource)"
        :user-id="plan.user_id"
        :period="period"
      ></engagement-tracker>
    </engagement-tracker>
    -->

    <engagement-tracker
      v-if="versionLt(3)"
      label="Appointments"
      help="All appointments set should be counted."
      variant="container"
      icon="fa-calendar"
      class="mb-3"
      type="App\Engagements\Simple\Appointment"
      :user-id="plan.user_id"
      :period="period"
    >
      <engagement-tracker
        v-for="leadSource in leadSources"
        :key="leadSource.name"
        :label="leadSourceName(leadSource)"
        variant="nested"
        type="App\Engagements\Simple\Appointment"
        :lead-source="leadSourceName(leadSource)"
        :user-id="plan.user_id"
        :period="period"
      ></engagement-tracker>
    </engagement-tracker>


    <engagement-tracker
      v-if="versionGte(3)"
      label="Listing Appointments Set"
      help="All listing appointments set should be counted."
      variant="container"
      icon="fa-calendar"
      class="mb-3"
      type="App\Engagements\Simple\ListingAppointment"
      :user-id="plan.user_id"
      :period="period"
    >
      <engagement-tracker
        v-for="leadSource in leadSources"
        :key="leadSource.name"
        :label="leadSourceName(leadSource)"
        variant="nested"
        type="App\Engagements\Simple\ListingAppointment"
        :lead-source="leadSourceName(leadSource)"
        :user-id="plan.user_id"
        :period="period"
      ></engagement-tracker>
    </engagement-tracker>

    <engagement-tracker
      v-if="versionGte(3)"
      label="Buyer Appointments Set"
      tip="New clients only"
      help="Only new client buyer consultations/showings set should be counted."
      variant="container"
      icon="fa-calendar"
      class="mb-3"
      type="App\Engagements\Simple\BuyerConsultation"
      :user-id="plan.user_id"
      :period="period"
    >
      <engagement-tracker
        v-for="leadSource in leadSources"
        :key="leadSource.name"
        :label="leadSourceName(leadSource)"
        variant="nested"
        type="App\Engagements\Simple\BuyerConsultation"
        :lead-source="leadSourceName(leadSource)"
        :user-id="plan.user_id"
        :period="period"
      ></engagement-tracker>
    </engagement-tracker>

    <engagement-tracker
      v-if="versionGte(3)"
      label="Tenant Rep Appointment"
      tip="New clients only"
      help="Only new client tenant rep appointments set should be counted."
      variant="container"
      icon="fa-calendar"
      class="mb-3"
      type="App\Engagements\Simple\TenantRepAppointment"
      :user-id="plan.user_id"
      :period="period"
    >
      <engagement-tracker
        v-for="leadSource in leadSources"
        :key="leadSource.name"
        :label="leadSourceName(leadSource)"
        variant="nested"
        type="App\Engagements\Simple\TenantRepAppointment"
        :lead-source="leadSourceName(leadSource)"
        :user-id="plan.user_id"
        :period="period"
      ></engagement-tracker>
    </engagement-tracker>

    <engagement-tracker
      v-if="versionGte(3)"
      label="Landlord Rep Appointment"
      tip="New clients only"
      help="Only new client landlord rep appointments set should be counted."
      variant="container"
      icon="fa-calendar"
      class="mb-3"
      type="App\Engagements\Simple\LandlordRepAppointment"
      :user-id="plan.user_id"
      :period="period"
    >
      <engagement-tracker
        v-for="leadSource in leadSources"
        :key="leadSource.name"
        :label="leadSourceName(leadSource)"
        variant="nested"
        type="App\Engagements\Simple\LandlordRepAppointment"
        :lead-source="leadSourceName(leadSource)"
        :user-id="plan.user_id"
        :period="period"
      ></engagement-tracker>
    </engagement-tracker>

    <engagement-tracker
      label="Listing Agreements"
      help="All listing agreements you sign should be counted."
      variant="container"
      icon="fa-pencil"
      class="mb-3"
      type="App\Engagements\Simple\ListingAgreement"
      :user-id="plan.user_id"
      :period="period"
    >
      <engagement-tracker
        v-for="leadSource in leadSources"
        :key="leadSource.name"
        variant="nested"
        :label="leadSourceName(leadSource)"
        type="App\Engagements\Simple\ListingAgreement"
        :lead-source="leadSourceName(leadSource)"
        :user-id="plan.user_id"
        :period="period"
      ></engagement-tracker>
    </engagement-tracker>

    <engagement-tracker
      v-if="versionGte(3)"
      label="Buyer Agreements"
      help="All buyer agreements you sign should be counted."
      variant="container"
      icon="fa-pencil"
      class="mb-3"
      type="App\Engagements\Simple\BuyerAgreement"
      :user-id="plan.user_id"
      :period="period"
    >
      <engagement-tracker
        v-for="leadSource in leadSources"
        :key="leadSource.name"
        variant="nested"
        :label="leadSourceName(leadSource)"
        type="App\Engagements\Simple\BuyerAgreement"
        :lead-source="leadSourceName(leadSource)"
        :user-id="plan.user_id"
        :period="period"
      ></engagement-tracker>
    </engagement-tracker>

    <engagement-tracker
      v-if="versionLt(3)"
      label="Open houses"
      help="All open houses you hold should be be counted."
      icon="fa-home"
      class="mb-3"
      type="App\Engagements\Simple\OpenHouse"
      :user-id="plan.user_id"
      :period="period"
    ></engagement-tracker>

    <engagement-tracker
      label="Outbounds"
      help="All referrals you place with Relocation should be counted."
      icon="fa-sign-out"
      type="App\Engagements\Simple\Outbound"
      :user-id="plan.user_id"
      :period="period"
    ></engagement-tracker>
  </div>
</template>

<script>
import wait from '@/lib/wait'
import moment from 'moment'
import EngagementTracker from '@/components/business-plan-editor/EngagementTracker'
import PowerHour from '@/components/PowerHour'
import compareVersions from 'compare-versions'
import { debounce, snakeCase, map, sum, get } from 'lodash'
import urls from '@/api/urls'

export default {
  components: {
    EngagementTracker,
    PowerHour
  },
  props: {
    showInfoAlert: {
      type: Boolean,
      default: true
    },
    plan: {
      type: Object,
      default () {
        return {
          lead_sources: [],
          quota_convos_daily: null,
          user_id: null
        }
      }
    },
    period: {
      type: String,
      default: 'day'
    },
    version: {
      type: Number,
      default () {
        return get(window, 'Redwood.businessPlan.version', 3)
      }
    }
  },
  data () {
    return {
      urls,
      history: {},
      mounted: false,
      convosTotal: 0,
      listingAppointmentsTotal: 0,
      listingAgreementsTotal: 0,
      buyerConsultationsTotal: 0,
      openHousesTotal: 0,
      outboundsTotal: 0,
      convosQuotaStatus: ''
    }
  },
  computed: {
    leadSources () {
      return this.plan.lead_sources
    },
    quotaConvosDaily () {
      return this.plan.quota_convos_daily
    },
    quotaConvos () {
      if (this.period === 'day') {
        return this.quotaConvosDaily
      } else if (this.period === 'week') {
        return this.quotaConvosDaily * 5
      } else if (this.period === 'month') {
        return Math.ceil(this.quotaConvosDaily * 5 * 40 / 12)
      } else if (this.period === 'year') {
        return this.quotaConvosDaily * 5 * 40
      } else {
        return this.quotaConvosDaily
      }
    },
    today () {
      return moment().format('MMM D')
    },
    convosUntilDailyQuota () {
      return this.quotaConvosDaily - this.convosTotal
    },
    convosUntilQuota () {
      return this.quotaConvos - this.convosTotal
    }
  },
  watch: {
    period () {
      this.updateConvosQuotaStatus()
    }
  },
  mounted () {
    this.$on('childEngagementTracker.updated', (userId, type, period, leadSource, count) => {
      if (type === 'App\\Engagements\\Simple\\Conversation') {
        this.convosTotal = count
      }
      if (type === 'App\\Engagements\\Simple\\ListingAppointment') {
        this.listingAppointmentsTotal = count
      }
      if (type === 'App\\Engagements\\Simple\\ListingAgreement') {
        this.listingAgreementsTotal = count
      }
      if (type === 'App\\Engagements\\Simple\\BuyerConsultation') {
        this.buyerConsultationsTotal = count
      }
      if (type === 'App\\Engagements\\Simple\\OpenHouse') {
        this.openHousesTotal = count
      }
      if (type === 'App\\Engagements\\Simple\\Outbound') {
        this.outboundsTotal = count
      }
      this.updateConvosQuotaStatus()
    })
  },
  methods: {
    versionGte (compare) {
      return compareVersions.compare(this.version.toString(), compare.toString(), '>=')
    },
    versionLt (compare) {
      return compareVersions.compare(this.version.toString(), compare.toString(), '<')
    },
    versionLte (compare) {
      return compareVersions.compare(this.version.toString(), compare.toString(), '<=')
    },
    snake (str) {
      return snakeCase(str)
    },
    leadSourceName (source) {
      if (source.name === 'Custom') {
        return source.custom
      } else if (source.name === 'Geographic Farm') {
        return source.custom ? `Geo Farm: ${source.custom}` : 'Geographic Farm'
      } else {
        return source.name
      }
    },
    updateConvosQuotaStatus () {
      let status = ''
      if (this.quotaConvos < 1) {
        status = `I need to finish building my business plan today.`
      } else if (this.period === 'day') {
        if (this.convosUntilDailyQuota === this.quotaConvosDaily) {
          status = `I need to have <b>${this.quotaConvosDaily} conversations</b> today.`
        } else if (this.convosUntilDailyQuota < 1) {
          status = `I rocked today! <b>${this.convosTotal} ${this.convosTotal === 1 ? 'conversation' : 'conversations'}</b> and still going.`
        } else {
          status = `I need <b>${this.convosUntilDailyQuota} more ${this.convosUntilDailyQuota === 1 ? 'conversation' : 'conversations'}</b> to make my daily number.`
        }
      } else {
        if (this.convosUntilQuota > 0) {
          status = `I need to have ${this.convosUntilQuota} more conversations this ${this.period}.`
        } else {
          status = `I'm a rock star.`
        }
      }
      if (this.listingAppointmentsTotal > 0) {
        status = `${status} ${this.listingAppointmentsTotal} listing ${this.listingAppointmentsTotal === 1 ? 'appointment' : 'appointments'} set. Woo-hoo!`
      }
      this.convosQuotaStatus = status
    }
  }
}
</script>